import { render, staticRenderFns } from "./customerDeposit.vue?vue&type=template&id=233a49f3&scoped=true&"
import script from "./customerDeposit.vue?vue&type=script&lang=js&"
export * from "./customerDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233a49f3",
  null
  
)

export default component.exports